import { render, staticRenderFns } from "./Block.vue?vue&type=template&id=07d709c6&scoped=true&"
import script from "./Block.vue?vue&type=script&lang=ts&"
export * from "./Block.vue?vue&type=script&lang=ts&"
import style0 from "./Block.vue?vue&type=style&index=0&id=07d709c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d709c6",
  null
  
)

export default component.exports